export default {
  name: 'name_valid_characters',
  validate: (value: string | null): boolean => {
    if (!value) {
      return true;
    }

    return /(?!(?:.*\/[\/\*]+)|(?:.*\*\/+)|(?:.*-{2,}))^[^<>\\:;""=\r\n]*$/.test(value)
  }
};
